var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"platform-list"},_vm._l((_vm.platforms),function(platform){return _c('div',{key:platform,staticClass:"badge"},[_c('ts-icon',{attrs:{"icon":platform,"size":"x-small","color":"#6d7587"}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }